import { $axios } from 'src/boot/axios';

const defaultState = () => ({
  generation: {
    documents: [],
  },
  imagesUpdateAvailable: false,
  template: undefined,
  isGenerationStopped: false,
});

const getters = {
  images: (state) => state.generation.documents,
};

const actions = {
  async generateImages({ commit }, { meta }) {
    const { data } = await $axios.post('generator/generations', {
      data: {
        templateType: 'images',
        meta,
      },
      documentsCount: 1,
    });
    commit('setGeneration', data.data);
    return data.data;
  },
  async fetchImages({ commit, state }, { guid }) {
    const { data } = (await $axios.get(`generator/generations/${guid}`)).data;
    if (state.imagesUpdateAvailable) {
      commit('setGeneration', data);
    }
    return data.documents;
  },
  async fetchTemplate({ commit }) {
    const { data } = await $axios.get('generator/templates/images');
    commit('setTemplate', data.data);
  },
};

const mutations = {
  setGeneration(state, payload) {
    state.generation = payload;
  },
  setTemplate(state, payload) {
    state.template = payload;
  },
  setGenerationStopped(state, payload) {
    state.isGenerationStopped = payload;
  },
  clear(state) {
    const clearState = defaultState();
    Object.keys(clearState).forEach((key) => {
      state[key] = clearState[key];
    });
  },
  updateAvailability(state, payload) {
    state.imagesUpdateAvailable = payload;
  },
  updateImageStatusByGUID(state, { guid, status }) {
    const documents = state.generation.documents.map((item) => (item.guid === guid ? { ...item, status } : item));
    state.generation.documents = documents;
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state: defaultState,
  getters,
};
